import { z } from "zod";

import { multiSelectResponseSchema } from "../../common/schemaHelper";

/**
 * Weight History validation schema
 * Validates the entire weightHistory category
 */

export const weightHistoryValidation = z.object({
  weightGainStart: z.string().min(1, "Please select an option"),
  weightGainInfluence: z.array(z.string()).min(1, "Please select at least one option"),
  weightTrend: z.string().min(1, "Please select an option"),
  goalWeight: z.string().optional(),
  goalWeightUnit: z.enum(["lbs", "kg"]).optional(),
  weightGoalDescription: z
    .array(multiSelectResponseSchema)
    .min(1, "Please select at least one option"),
});

export default weightHistoryValidation;
